var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"dashboard-ecommerce"}},[_c('br'),_c('home-medal',{attrs:{"resultSoc":_vm.ResultSoc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }